import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';

var Shortcut = function Shortcut(_ref) {
  var keys = _ref.keys,
    inverted = _ref.inverted,
    themeProps = _ref.themeProps;
  return jsx("div", {
    role: "definition",
    "aria-label": "Keyboard Shortcut " + keys.join(' plus '),
    children: keys.map(function (key) {
      return jsx("span", {
        className: classNames.apply(undefined, ['cogs-v10', 'cogs-shortcut'].concat(getThemeClassNames(inverted, themeProps))),
        children: key
      }, key);
    })
  });
};

export { Shortcut };
